import format from 'date-fns/format';
export function formatDateISO(value) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date.toISOString();
}
export function formatDate(value, formatString = 'dd.MM.yyyy') {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return format(date, formatString);
}
